<template>
    <div>
        <div class="actions-tab in-tab">
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret style="margin-right: 83px;">
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-download"></i> Скачать
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="downloadRep">ПКФО-1</b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="table-container">
            <table class="table b-table table-bordered b-table-no-border-collapse">
                <thead>
                <tr>
                    <th v-for="(field, index) in tableFields" class="text-center" :key="index"
                        :rowspan="field.rowspan || 1" :colspan="field.colspan || 1"
                        :style="{ width: index === 0 ? '800px' : index === 2 ? '200px' : '' }"
                        v-html="field.key === 'evaluation' ? getEvaluationLabel() : field.label">
                    </th>
                </tr>
                <tr>
                    <th v-for="year in forecastYears" class="text-center" :key="year">{{ year }}</th>
                </tr>
                </thead>
                <tbody v-for="(row, index) in formPkfo1" :key="index" class="table-info"
                       :style="{ backgroundColor: (row.line_code) ? 'white' : '' }">
                <tr>
                    <td>{{ row.name_ru}}</td>
                    <td class="text-center">{{ row.line_code }}</td>
                    <td class="text-right">
                        <span v-if="row.fact">{{ $n(toNum(row.fact)) }}</span>

                        <span
                            v-if="hasError(row.line_code, 'fact')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'fact').text"
                        >⚠</span>
                    </td>
                    <td v-if="actualVersion && row.line_code && !notInputList.includes(row.line_code) && !row.line_code.endsWith('00')">
                        <span
                            v-if="hasError(row.line_code, 'evaluation')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'evaluation').text"
                        >⚠</span>
                        <input type="number" v-model="row.evaluation" @blur="blurInput(row, 'evaluation')"
                               @input="formatDecimal(row, 'evaluation')"
                               :class="{ 'disabled-input': access_level === 1 }"
                               :disabled="access_level === 1"
                               class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                    </td>
                    <td v-else-if="row.evaluation" class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'evaluation')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'evaluation').text"
                        >⚠</span>{{ $n(toNum(row.evaluation)) }}
                    </td>
                    <td v-else></td>
                    <td v-if="actualVersion && row.line_code && !notInputList.includes(row.line_code) && !row.line_code.endsWith('00')">
                        <span
                            v-if="hasError(row.line_code, 'forecast_1')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'forecast_1').text"
                        >⚠</span>
                        <input type="number" v-model="row.forecast_1" @blur="blurInput(row, 'forecast_1')"
                               @input="formatDecimal(row, 'forecast_1')"
                               :class="{ 'disabled-input': access_level === 1 }"
                               :disabled="access_level === 1"
                               class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                    </td>
                    <td v-else-if="row.forecast_1" class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'forecast_1')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'forecast_1').text"
                        >⚠</span>{{ $n(toNum(row.forecast_1)) }}
                    </td>
                    <td v-else></td>
                    <td v-if="actualVersion && row.line_code && !notInputList.includes(row.line_code) && !row.line_code.endsWith('00')">
                        <span
                            v-if="hasError(row.line_code, 'forecast_2')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'forecast_2').text"
                        >⚠</span>
                        <input type="number" v-model="row.forecast_2" @blur="blurInput(row, 'forecast_2')"
                               @input="formatDecimal(row, 'forecast_2')"
                               :class="{ 'disabled-input': access_level === 1 }"
                               :disabled="access_level === 1"
                               class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                    </td>
                    <td v-else-if="row.forecast_2" class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'forecast_2')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'forecast_2').text"
                        >⚠</span>{{ $n(toNum(row.forecast_2)) }}
                    </td>
                    <td v-else></td>
                    <td v-if="actualVersion && row.line_code && !notInputList.includes(row.line_code) && !row.line_code.endsWith('00')">
                        <span
                            v-if="hasError(row.line_code, 'forecast_3')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'forecast_3').text"
                        >⚠</span>
                        <input type="number" v-model="row.forecast_3" @blur="blurInput(row, 'forecast_3')"
                               @input="formatDecimal(row, 'forecast_3')"
                               :class="{ 'disabled-input': access_level === 1 }"
                               :disabled="access_level === 1"
                               class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                    </td>
                    <td v-else-if="row.forecast_3" class="text-right">
                        <span
                            v-if="hasError(row.line_code, 'forecast_3')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'forecast_3').text"
                        >⚠</span>{{ $n(toNum(row.forecast_3)) }}
                    </td>
                    <td v-else></td>
                </tr>
                </tbody>
            </table>
            <table class="table b-table table-bordered b-table-no-border-collapse">
                <thead>
                <tr>
                    <th v-for="(field, index) in secondTableFields" class="text-center" :key="index"
                        :rowspan="field.rowspan || 1" :colspan="field.colspan || 1"
                        :style="{ width: index === 0 ? '800px' : index === 2 ? '200px' : '' }"
                        v-html="field.key === 'evaluation' ? getEvaluationLabel() : field.label">
                    </th>
                </tr>
                <tr>
                    <th v-for="year in forecastYears" class="text-center" :key="year">{{ year }}</th>
                </tr>
                </thead>
                <tbody v-for="(row, index) in formPkfo2" :key="index" class="table-info"
                       :style="{ backgroundColor: (row.line_code) ? 'white' : '' }">
                <tr>
                    <td>{{ row.name_ru}}</td>
                    <td class="text-center">{{ row.line_code }}</td>
                    <td class="text-right">
                        <span v-if="row.fact">{{ $n(toNum(row.fact)) }}</span>

                        <span
                            v-if="hasError(row.line_code, 'fact')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'fact').text"
                        >⚠</span>
                    </td>
                    <td v-if="actualVersion && row.line_code && !notInputList2.includes(row.line_code) && row.line_code !== '01'
                    && !row.line_code.endsWith('00')">
                        <span
                            v-if="hasError(row.line_code, 'evaluation')"
                            class="warning-icon"
                            :title="hasError(row.line_code, 'evaluation').text"
                        >⚠</span>
                        <input type="number" v-model="row.evaluation" @blur="blurInput(row, 'evaluation')"
                               @input="formatDecimal(row, 'evaluation')"
                               :class="{ 'disabled-input': access_level === 1 }"
                               :disabled="access_level === 1"
                               class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                    </td>
                    <td v-else-if="row.evaluation" class="text-right">
                        <span
                        v-if="hasError(row.line_code, 'evaluation')"
                        class="warning-icon"
                        :title="hasError(row.line_code, 'evaluation').text"
                    >⚠</span>{{ $n(toNum(row.evaluation)) }}
                    </td>
                    <td v-else></td>
                    <td v-if="actualVersion && row.line_code && !notInputList2.includes(row.line_code) && row.line_code !== '01'
                    && !row.line_code.endsWith('00')">
                         <span
                             v-if="hasError(row.line_code, 'forecast_1')"
                             class="warning-icon"
                             :title="hasError(row.line_code, 'forecast_1').text"
                         >⚠</span>
                        <input type="number" v-model="row.forecast_1" @blur="blurInput(row, 'forecast_1')"
                               @input="formatDecimal(row, 'forecast_1')"
                               :class="{ 'disabled-input': access_level === 1 }"
                               :disabled="access_level === 1"
                               class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                    </td>
                    <td v-else-if="row.forecast_1" class="text-right">
                         <span
                             v-if="hasError(row.line_code, 'forecast_1')"
                             class="warning-icon"
                             :title="hasError(row.line_code, 'forecast_1').text"
                         >⚠</span>{{ $n(toNum(row.forecast_1)) }}
                    </td>
                    <td v-else></td>
                    <td v-if="actualVersion && row.line_code && !notInputList2.includes(row.line_code) && row.line_code !== '01'
                    && !row.line_code.endsWith('00')">
                         <span
                             v-if="hasError(row.line_code, 'forecast_2')"
                             class="warning-icon"
                             :title="hasError(row.line_code, 'forecast_2').text"
                         >⚠</span>
                        <input type="number" v-model="row.forecast_2" @blur="blurInput(row, 'forecast_2')"
                               @input="formatDecimal(row, 'forecast_2')"
                               :class="{ 'disabled-input': access_level === 1 }"
                               :disabled="access_level === 1"
                               class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                    </td>
                    <td v-else-if="row.forecast_2" class="text-right">
                         <span
                             v-if="hasError(row.line_code, 'forecast_2')"
                             class="warning-icon"
                             :title="hasError(row.line_code, 'forecast_2').text"
                         >⚠</span>{{ $n(toNum(row.forecast_2)) }}
                    </td>
                    <td v-else></td>
                    <td v-if="actualVersion && row.line_code && !notInputList2.includes(row.line_code) && row.line_code !== '01'
                    && !row.line_code.endsWith('00')">
                         <span
                             v-if="hasError(row.line_code, 'forecast_3')"
                             class="warning-icon"
                             :title="hasError(row.line_code, 'forecast_3').text"
                         >⚠</span>
                        <input type="number" v-model="row.forecast_3" @blur="blurInput(row, 'forecast_3')"
                               @input="formatDecimal(row, 'forecast_3')"
                               :class="{ 'disabled-input': access_level === 1 }"
                               :disabled="access_level === 1"
                               class="form-control no-spinner" style="text-align: right;" step="0.1"/>
                    </td>
                    <td v-else-if="row.forecast_3" class="text-right">
                         <span
                             v-if="hasError(row.line_code, 'forecast_3')"
                             class="warning-icon"
                             :title="hasError(row.line_code, 'forecast_3').text"
                         >⚠</span>{{ $n(toNum(row.forecast_3)) }}
                    </td>
                    <td v-else></td>
                </tr>
                </tbody>
            </table>
            <loading
                :active="loading"
                is-full-screen
                spinner="bar-fade-scale"
                color="#6495ED"
            />
        </div>
    </div>
</template>
<script>

import VueElementLoading from "vue-element-loading";
import moment from "moment/moment";
import {Ax} from "@/utils";

export default {
    name: 'forecast-pkfo1',
    components: {
        'loading': VueElementLoading
    },
    props: {
        year: Number,
        region: String,
        version: String,
        abp: Number,
        dataType: Number,
        region_name: String,
        version_name: String,
        obl: String,
        actualVersion: Boolean,
        access_level: Number,
        checkDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            open: false,
            tableFields: [
                {
                    key: 'name_ru',
                    label: 'Активы',
                    rowspan: 2
                },
                {
                    key: 'line_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: 'Факт, ТЫС.ТЕҢГЕ',
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: 'Оценка*, ТЫС.ТЕҢГЕ',
                    rowspan: 1
                },
                {
                    key: 'forecast',
                    label: 'Прогноз, ТЫС.ТЕҢГЕ',
                    colspan: 3
                }],
            secondTableFields: [
                {
                    key: 'name_ru',
                    label: 'ОБЯЗАТЕЛЬСТВА, ЧИСТЫЕ АКТИВЫ/КАПИТАЛ',
                    rowspan: 2
                },
                {
                    key: 'line_code',
                    label: 'Код строки',
                    rowspan: 2
                },
                {
                    key: 'fact',
                    label: 'Факт, ТЫС.ТЕҢГЕ',
                    rowspan: 1
                },
                {
                    key: 'evaluation',
                    label: 'Оценка*, ТЫС.ТЕҢГЕ',
                    rowspan: 1
                },
                {
                    key: 'forecast',
                    label: 'Прогноз, ТЫС.ТЕҢГЕ',
                    colspan: 3
                }],
            formPkfo1: [],
            formPkfo2: [],
            openRows: {},
            repdate: null,
            inputValues: [],
            notInputList: ['011', '016', '020', '110', '114', '115', '116', '117', '118'],
            notInputList2: ['210', '213', '219', '221', '310', '313', '412']

        }
    },
    async mounted() {
        await this.LoadPKFO1();
    },
    computed: {
        forecastYears() {
            return [this.year - 2, this.year - 1, this.year, this.year + 1, this.year + 2];
        }
    },
    methods: {
        hasError(lineCode, field) {
            return this.checkDataList.find(item =>
                (
                    item.checked_form === 'pkfo1' &&
                    String(item.checked_line_code) === String(lineCode)
                ) |
                (
                    item.agreed_form === 'pkfo1' &&
                    String(item.agreed_line_code) === String(lineCode)
                )
                && item[field]);
        },
        getEvaluationLabel() {
            if (!this.repdate) {
                return `Оценка*, тыс.теңге`;
            }
            return `<span title="Оценочные данные\nактуальны на дату:\n${this.formatDate(this.repdate)}"
                style="cursor: pointer;">Оценка*, тыс.теңге</span>`;
        },
        formatDate(date) {
            if (date !== null){
                return new Date(date).toLocaleDateString('ru-RU', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
            }
        },
        formatDecimal(child, field) {
            let value = child[field].toString();
            if (value.includes('.')) {
                value = value.replace(/(\.\d).*/, '$1'); // Keep only one digit after '.'
            }
            child[field] = value;
        },
        blurInput(child, data, isInitialLoad = false) {
            let parsedValue;
            if (child[data] === undefined || child[data] === null || child[data] === "") {
                parsedValue = null;
            } else {
                parsedValue = parseFloat(child[data]) || 0;
            }
            if (!isInitialLoad && child[data] !== null && child[data] !== 0) {
                const existingEntryIndex = this.inputValues.findIndex(entry => entry.code === child.line_code);
                if (existingEntryIndex !== -1) {
                    // Update the specific field for an existing entry
                    this.$set(this.inputValues[existingEntryIndex], data, parsedValue);
                } else if (parsedValue !== null) {
                    // Create a new entry if it doesn't exist and the value is not null
                    const newEntry = {
                        code: child.line_code,
                        evaluation: data === 'evaluation' ? parsedValue : null,
                        forecast_1: data === 'forecast_1' ? parsedValue : null,
                        forecast_2: data === 'forecast_2' ? parsedValue : null,
                        forecast_3: data === 'forecast_3' ? parsedValue : null
                    };
                    this.inputValues.push(newEntry);
                }
            }

            let totalRow;
            let sumRows;
            if (child.section === 1) {
                totalRow = this.formPkfo1.find(item => item.subsection === child.subsection
                    && item.line_code && item.line_code.endsWith('00') && item.line_code.length === 3);
                sumRows = this.formPkfo1.filter(item => item.subsection === child.subsection
                    && item.line_code && !item.line_code.endsWith('00'));
            } else {
                totalRow = this.formPkfo2.find(item => item.subsection === child.subsection
                    && item.line_code && item.line_code.endsWith('00') && item.line_code.length === 3);
                sumRows = this.formPkfo2.filter(item => item.subsection === child.subsection
                    && item.line_code && !item.line_code.endsWith('00') && item.line_code.length === 3);
            }
            if (totalRow && sumRows) {
                const res = sumRows.reduce((acc, row) => acc + (parseFloat(row[data]) || 0), 0);
                this.$set(totalRow, data, this.toNum(res));
            }

            let balnceRow;
            let sumTotals;
            if (child.section === 1) {
                balnceRow = this.formPkfo1.find(item => item.line_code === '00');
                sumTotals = this.formPkfo1.filter(item => item.line_code && item.line_code.endsWith('00')
                    && item.line_code.length === 3);
            } else {
                balnceRow = this.formPkfo2.find(item => item.line_code === '01');
                sumTotals = this.formPkfo2.filter(item => item.line_code && item.line_code.endsWith('00')
                    && item.line_code.length === 3);
            }
            if (balnceRow && sumTotals) {
                const res = sumTotals.reduce((acc, row) => acc + (parseFloat(row[data]) || 0), 0);
                this.$set(balnceRow, data, this.toNum(res));
            }
        },
        async LoadPKFO1() {
           this.loading = true;
            try {
                const response = await fetch(`/api-py/get_dict_items_pkfo1/` + this.version + '/' + this.abp + '/' + this.year + '/' + this.obl + '/' + this.region);
                if (response.status === 200) {
                    const data = await response.json();
                    this.formPkfo1 = data.result1;
                    this.formPkfo2 = data.result2;
                    this.inputValues = data.input;
                    this.repdate = data.repdate;
                    const keysToBlur = ['evaluation', 'forecast_1', 'forecast_2', 'forecast_3'];

                    const applyBlur = (row) => {
                        keysToBlur.forEach(key => {
                            if (key in row) {
                                this.blurInput(row, key, true);
                            }
                        });
                    };

                    this.formPkfo1.forEach(applyBlur);
                    this.formPkfo2.forEach(applyBlur);
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка ПКФО-1', error.toString());
            }
            this.loading = false;
        },
        async SaveData() {
            if (Object.keys(this.inputValues).length > 0) {
                this.inputData = [];
                const item = Object.assign({});

                this.$set(item, 'inputValues', this.inputValues);
                this.$set(item, 'cur_year', this.year);
                this.$set(item, 'budget_variant', this.version);
                this.$set(item, 'abp_code', this.abp);
                this.$set(item, 'user_id', this.$store.getters.user_uuid);
                this.$set(item, 'update_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'code_form', 'pkfo1');
                this.$set(item, 'region_code', this.region);
                this.$set(item, 'data_type', this.dataType);
                this.isLoad = true;
                this.inputData.push(item);
                try {
                    const response = await fetch('/api-py/add_data_to_pkfo_1', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.inputData)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.isSave = false;
                        await this.LoadPKFO1();
                        this.makeToast('success', 'Сообщение', 'Данные сохранены');
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }

        },
        downloadRep() {
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                this.isLoad = true;
                this.curParams = { year: this.year, region: this.region, version: this.version, abp: this.abp, data_type: this.dataType, reg_name: this.region_name, ver_name: this.version_name, obl: this.obl };
                Ax(
                    {
                        url: '/api-py/forecast_reporting_download_pkfo_1/' + JSON.stringify(this.curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'ПКФО-1.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            } finally {
                this.isLoad = false
            }
        },
        toggleRow(index) {
            this.$set(this.openRows, index, !this.openRows[index]);
        },
        toNum(value, fix = 1) {
            if (typeof (value) === 'string') {
                return parseFloat(parseFloat(value).toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined') {
                return 0;
            }
            if (isNaN(value)) {
                return 0;
            }
            if (isFinite(value)) {
                return 0;
            }
            if (value === null) {
                return 0;
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
    }
}
</script>
